//  ----------      START   IMPORT  BLOCK       ----------
//  Config
import './ImageRowWidget.css';
//  ----------      END   IMPORT  BLOCK       ----------

const ImageRowWidget = ({ images }) => {
  return (
    <div className="image-row-widget">
      {images.map((src, index) => (
        <img key={index} src={src} alt={`img-${index}`} className="circle-img" />
      ))}
    </div>
  );
};

export default ImageRowWidget;
